import styled from 'styled-components'
import {
  COLOR,
  FONT_SIZE,
  BUTTON_SIZE,
  Z_INDEXS,
} from '../../../themes'
import { colorThemeSelector } from '../../../helpers'
const padding = 70
export const StyleModal = styled.div`
  .div-Modal{
    background: ${COLOR.BLACK_1};
    border: 1px solid ${COLOR.GRAY_10};
    display: block;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0.7;
    z-index: ${Z_INDEXS.LV_10};
  }
  .btn-modal {
    bottom: 0;
    margin-bottom: auto;
  }
  .tabel {
    color: ${COLOR.BLACK_1};
    display: table;
    border-collapse: collapse;
    width: 100%;
    background: ${COLOR.WHITE}
  }

  .table-row{
    display: table-row;
    font-size: ${FONT_SIZE.TN};
  }

  .table-cell, .table-cell-default{
    display: table-cell;
    vertical-align: middle;
  }

  .table-row-border-header{
    display: table-row;
    font-size: ${FONT_SIZE.MN};
    border-bottom: 1px solid ${COLOR.GRAY_5};
  }

  .table-row-border{
    display: table-row;
    font-size: ${FONT_SIZE.MN};
    border-bottom: 1px solid ${COLOR.GRAY_5};
  }

  .table-row-block{
    width: 10px;
    height: 70px;
    background: ${COLOR.BLUE_1};
    float: left;
    display: none;
  }
  
  .table-row-border:hover {
    -webkit-box-shadow: 0px 4px 6px 1px ${COLOR.GOLD_1};
    -moz-box-shadow: 0px 4px 6px 1px ${COLOR.GOLD_1};
    box-shadow: 0px 4px 6px 1px ${COLOR.GOLD_1};
    .table-row-block {
      display: block;
    }
    .first{
      padding-left: 16px;
    }
  }

  .table-cell{
    line-height: 70px;
  }


  .sub-content {
    padding: 60px;
  }
  .content-Modal{
    border-radius: 8px;
    z-index: ${Z_INDEXS.LV_10};
    color: ${COLOR.BLACK_1};
    display: block;
    position: fixed;
    background: ${COLOR.WHITE};
    top: 20%;
    height: 420px;
    width: ${660 - padding}px;
    font-size: ${FONT_SIZE.SM};
    padding-left: ${padding}px;
    padding-right: ${padding}px;
    text-align: center;
    left: 0;
    right: 0;
    margin: auto;
    -webkit-animation-name: example; /* Safari 4.0 - 8.0 */
    -webkit-animation-duration: 0.5s; /* Safari 4.0 - 8.0 */
    animation-name: example;
    animation-duration: 0.5s;
  }


  /* Safari 4.0 - 8.0 */
  @-webkit-keyframes example {
    0%   {
      padding-left: 30px;
      padding-right: 30px;
    }
    100%  {
      padding-left: ${padding}px;
      padding-right: ${padding}px;
    }
  }

  /* Standard syntax */
  @keyframes example {
    0%   {
      padding-left: 30px;
      padding-right: 30px;
    }
    100%  {
      padding-left: ${padding}px;
      padding-right: ${padding}px;
    }
  }

  .head-modal{
    font-size: ${FONT_SIZE.XXL};
    font-weight: bold;
    letter-spacing: 1px;
  }

  .description{
    margin-top: 30px;
    font-size: ${FONT_SIZE.XS};
    color: ${COLOR.BLACK_1};
  }

  .input-delete{
    margin-top: 50px;
    border: none;
    width: 100%;
    outline: none;
    border-bottom: 1px solid ${COLOR.BLACK_1};
    font-size: ${FONT_SIZE.XS};
    padding-bottom: 6px;
    ::placeholder {
      font-size: ${FONT_SIZE.XS};
      color: ${COLOR.GRAY_3}

    }
  }

  .modal-btn-delete, .modal-btn-keep{
    width: 196px;
    margin-top: 30px;
    font-family: NunitoRegular;
    font-size: ${FONT_SIZE.XXS};
    line-height:${BUTTON_SIZE.LINE_HEIGHTS.MD};
    border: 1px solid ${COLOR.GRAY_6};
    background: ${COLOR.WHITE};
    float: none;
    color: ${COLOR.BLACK_1};
  }

  .modal-btn-delete{
    border: 1px solid ${COLOR.PEARL};
    background: ${COLOR.PEARL};
    margin-left: 10px;
    color: ${({ colorTheme }) => colorThemeSelector(colorTheme).FONT_COLOR.TEXT ?? COLOR.BLACK_1};
    cursor: not-allowed;
  }

  .is-pass{
    border: 1px solid ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    background-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    cursor: pointer;
  }

  .text-error{
    margin-top: 10px;
    font-size: ${FONT_SIZE.TN};
    color: ${COLOR.GOLD_1};
  }
  

`
